import { useContext, useState } from 'react';
import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Button } from '@cognite/cogs-core-v11/components/button/button.tsx';
import { EmptyState } from '@cognite/cogs-core-v11/components/empty-state/empty-state.tsx';
import { LogoutIcon } from '@cognite/cogs-icons-v11/system-icons/LogoutIcon.tsx';
import { SettingsIcon } from '@cognite/cogs-icons-v11/system-icons/SettingsIcon.tsx';

import { PageContainerStyle } from '../../../pages/elements';

import { AppConfigErrorScreenContext } from './app-config-error-screen.context';
import * as S from './elements';

export interface AppConfigErrorScreenProps {
  title: string;
  body: string;
}

export const AppConfigErrorScreen: FC<AppConfigErrorScreenProps> = ({
  title,
  body,
}) => {
  const {
    useInfieldLogout,
    useIsDesktop,
    useIsAppConfiguratorQuery,
    AppConfigView,
  } = useContext(AppConfigErrorScreenContext);

  const { t } = useTranslation('user');
  const { logout } = useInfieldLogout();
  const isDesktop = useIsDesktop();
  const { data: hasAppConfigPermission } = useIsAppConfiguratorQuery();
  const [showAppConfig, setShowAppConfig] = useState(false);

  return (
    <PageContainerStyle>
      <S.ErrorStateContainer>
        <EmptyState
          title={title}
          primaryAction={
            <Button type="ghost" icon={<LogoutIcon />} onClick={logout}>
              {t('USER_ERROR_LOCATION_MISSING_LOGOUT_BUTTON', 'Logout')}
            </Button>
          }
          description={body}
          secondaryAction={
            hasAppConfigPermission && isDesktop ? (
              <Button
                type="ghost"
                icon={<SettingsIcon />}
                onClick={() => setShowAppConfig(true)}
              >
                {t(
                  'USER_ERROR_LOCATION_MISSING_GOTO_CONFIGURATION_BUTTON',
                  'Go to configuration'
                )}
              </Button>
            ) : null
          }
        />
        <S.StyledModal
          title="App configuration"
          visible={showAppConfig}
          size="full-screen"
          onCancel={() => setShowAppConfig(false)}
          onOk={() => setShowAppConfig(false)}
          disableEnforceFocus
        >
          <AppConfigView />
        </S.StyledModal>
      </S.ErrorStateContainer>
    </PageContainerStyle>
  );
};
